import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Target, CheckSquare, FolderKanban, Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useLang } from '@/context/LanguageContext';
import { TEST_IDS } from '@/constants/testIds/app';

const items = [
  { to: '/dashboard', labelKey: 'nav.dashboard', icon: LayoutDashboard, tid: TEST_IDS.nav.dashboard },
  { to: '/goals', labelKey: 'nav.goals', icon: Target, tid: TEST_IDS.nav.goals },
  { to: '/tasks', labelKey: 'nav.tasks', icon: CheckSquare, tid: TEST_IDS.nav.tasks },
  { to: '/projects', labelKey: 'nav.projects', icon: FolderKanban, tid: TEST_IDS.nav.projects },
  { to: '/ai', labelKey: 'nav.ai', icon: Sparkles, tid: TEST_IDS.nav.ai },
];

export const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLang();
  return (
    <nav className="fixed bottom-0 left-1/2 z-50 w-full max-w-[480px] -translate-x-1/2 border-t border-white/10 bg-[#07111F]/85 backdrop-blur-md">
      <div className="flex items-stretch justify-around px-2 pb-[max(8px,env(safe-area-inset-bottom))] pt-2">
        {items.map(({ to, labelKey, icon: Icon, tid }) => {
          const active = location.pathname === to;
          const isAi = to === '/ai';
          return (
            <button
              key={to}
              data-testid={tid}
              onClick={() => navigate(to)}
              className={cn(
                'flex min-h-12 flex-1 flex-col items-center justify-center gap-1 rounded-xl py-1 text-[11px] transition-colors',
                active ? 'text-brand-cyan' : 'text-foreground/55 hover:text-foreground/80'
              )}
            >
              <span
                className={cn(
                  'flex h-8 w-8 items-center justify-center rounded-full transition-colors',
                  isAi && active && 'bg-brand-cyan/15',
                  isAi && !active && 'bg-white/[0.04]',
                  active && !isAi && 'bg-white/[0.06]'
                )}
              >
                <Icon className="h-[18px] w-[18px]" />
              </span>
              <span className="font-medium">{t(labelKey)}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
